<template>
	<div class="container-fluid mt-4">
		<h1 class="text-center">Search</h1>
		<form class="my-5" role="search" @submit.prevent="searchIt" v-if="isOnline">
			<div class="input-group m-auto">
				<!-- <select class="form-select" v-model="itemType">
					<option value="meal" selected>Meal</option>
					<option value="drink">Drink</option>
				</select> -->
				<input
					class="form-control"
					v-model="search"
					type="search"
					placeholder="Search"
					aria-label="Search" />
				<button type="submit" class="btn btn-primary">
					<i class="bi bi-search"></i>
				</button>
			</div>
		</form>
		<div class="text-center" v-else-if="!isOnline && !groupedResults">
			<h1 class="text-center">You are offline</h1>
			<h2 class="text-center">Please connect to the internet</h2>
		</div>
		<h1 class="text-center mt-5" v-if="searching">SEARCHING...</h1>
		<glass-card
			v-for="(meals, date) in groupedResults"
			:key="date"
			class="mb-3 p-3">
			<h2>{{ date }}</h2>
			<div class="d-flex flex-row flex-wrap gap-5 cards">
				<food-card
					v-for="meal in meals"
					:key="meal.id"
					@click="selectMealCard(meal)"
					:meal="meal" />
			</div>
		</glass-card>
		<h1
			class="text-center mt-5"
			v-if="
				!searching && groupedResults && !Object.keys(groupedResults).length
			">
			NO RESULTS
		</h1>
		<food-detail-modal
			:meal="selectedMeal"
			:show="showFDM"
			@close="closeModal" />
	</div>
</template>

<script setup>
	import { ref, watch } from "vue"
	import Swal from "sweetalert2"
	import { useTokenStore } from "@/stores/token"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	import FoodDetailModal from "@/components/FoodDetailModal.vue"
	import FoodCard from "@/components/FoodCard.vue"
	import { lastMealUpdated, lastMealDeleted } from "@/utils/mealBus"
	import { useUserStore } from "@/stores/user"
	import { isOnline } from "@/utils/networkBus"
	import GlassCard from "@/components/GlassCard.vue"

	const tokenStore = useTokenStore()
	const userStore = useUserStore()

	// const itemType = ref("meal")
	const search = ref("")
	const searching = ref(false)
	const showFDM = ref(false)
	const selectedMeal = ref(null)
	const groupedResults = ref(null)
	// const user = ref({})

	function closeModal() {
		selectedMeal.value = null
		showFDM.value = false
	}

	function selectMealCard(meal) {
		selectedMeal.value = meal
		showFDM.value = true
	}

	async function searchIt() {
		try {
			searching.value = true
			// Make the POST request using fetch
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const params = {
				q: search.value,
				// type: itemType.value,
			}
			const ps = new URLSearchParams(params).toString()
			const response = await fetchWithAuth(`/api/search?${ps}`, {
				method: "GET",
				headers: {
					"User-Timezone": tz,
					// Authorization: `Bearer ${tokenStore.token}`,
				},
			})

			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			// Convert the response to JSON
			const responseData = await response.json()

			if (!response.ok) {
				// alert(responseData.message)
				Swal.fire({
					icon: "error",
					title: responseData.message ?? responseData.error,
				})
			} else {
				// Handle success
				// console.log(responseData)

				groupedResults.value = responseData
			}
			// }
		} catch (error) {
			// Handle error
			console.error("Error submitting meal:", error)
			Swal.fire({ icon: "error", title: error.message })
		}

		searching.value = false
	}

	watch(lastMealUpdated, (v) => {
		if (v && selectedMeal.value && selectedMeal.value.id === v.id) {
			selectedMeal.value = v
		}
		searchIt()
	})

	watch(lastMealDeleted, (v) => {
		searchIt()
	})

	watch(
		() => userStore.user,
		(v, ov) => {
			if (v) {
				if (search.value) searchIt()
			}
		},
		{ immediate: true }
	)
</script>

<style lang="less" scoped>
	form {
		margin: auto;
		select {
			max-width: 100px;
		}
		max-width: 500px;
	}

	@media only screen and (max-width: 768px) {
		.cards {
			justify-content: center;
		}
	}
</style>
